/**
 * MessageStatus indicator component.
 *
 * Renders check/double-check/blue-check icons for user message
 * delivery status: sending, sent, delivered, read.
 */

import type { MessageStatus } from "../../types";

/** Single check SVG (sent) */
const CHECK_SVG = `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="hana-status__icon"><path d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z" fill="currentColor"/></svg>`;

/** Double check SVG (delivered) */
const DOUBLE_CHECK_SVG = `<svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" class="hana-status__icon"><path d="M15.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L4.22 9.28a.75.75 0 011.06-1.06L8 10.94l6.72-6.72a.75.75 0 011.06 0z" fill="currentColor"/><path d="M18.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0l-.5-.5a.75.75 0 011.06-1.06l-.03.03 6.72-6.72a.75.75 0 011.06 0z" fill="currentColor" opacity="0.7"/></svg>`;

/**
 * Create a status indicator element for a user message.
 *
 * @param status - Current delivery status
 * @returns HTMLElement with the appropriate icon
 */
export function createStatusIndicator(status: MessageStatus): HTMLElement {
  const el = document.createElement("span");
  el.className = `hana-status hana-status--${status}`;
  el.setAttribute("role", "img");

  switch (status) {
    case "sending":
      el.setAttribute("aria-label", "Sending");
      el.innerHTML = `<span class="hana-status__sending"></span>`;
      break;
    case "sent":
      el.setAttribute("aria-label", "Sent");
      el.innerHTML = CHECK_SVG;
      break;
    case "delivered":
      el.setAttribute("aria-label", "Delivered");
      el.innerHTML = DOUBLE_CHECK_SVG;
      break;
    case "read":
      el.setAttribute("aria-label", "Read");
      el.innerHTML = DOUBLE_CHECK_SVG;
      break;
  }

  return el;
}
